import { SelectiveLogoProps } from './common';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

export const Logo = ({ isOpen, ...props }: SelectiveLogoProps) =>
  isOpen ? <LogoFull {...props} /> : <LogoIcon {...props} />;
